export default "__VITE_ASSET__UqX_CMWK__"